import request from 'services/request';
import { endpoints } from 'services';
import { paramsToFormData } from 'utils/utils';

export default {
  getMyLoginInfo: (): Promise<MyLoginInfoDto> =>
    request({
      url: endpoints.mypage.logininfo,
      method: 'get',
    }),
  postProjectList1: (params: ProjectListReqDto): Promise<CommonSearchListResDto> =>
    request({
      url: endpoints.mypage.b2b1,
      method: 'post',
      data: paramsToFormData(params),
    }),
  postStandbyScheduleList1: (params: ProjectListReqDto): Promise<CommonSearchListResDto> =>
    request({
      url: endpoints.mypage.b2b4,
      method: 'post',
      data: paramsToFormData(params),
    }),         
  postProjectAskList1: (params: ProjectListReqDto): Promise<CommonSearchListResDto> =>
    request({
      url: endpoints.mypage.b2b5,
      method: 'post',
      data: paramsToFormData(params),
    }),    
  postB2cProjectList1: (params: ProjectListReqDto): Promise<CommonSearchListResDto> =>
    request({
      url: endpoints.mypage.b2c1,
      method: 'post',
      data: paramsToFormData(params),
    }), 
  postSeminarList1: (params: ProjectListReqDto): Promise<CommonSearchListResDto> =>
    request({
      url: endpoints.mypage.seminar1,
      method: 'post',
      data: paramsToFormData(params),
    }),    
  postPmlProjectList1: (params: ProjectListReqDto): Promise<CommonSearchListResDto> =>
    request({
      url: endpoints.mypage.pml1,
      method: 'post',
      data: paramsToFormData(params),
    }),       
  postOperatorList1: (params: ProjectListReqDto): Promise<CommonSearchListResDto> =>
    request({
      url: endpoints.mypage.op1,
      method: 'post',
      data: paramsToFormData(params),
    }),   
  postNonOperatorList1: (params: ProjectListReqDto): Promise<CommonSearchListResDto> =>
    request({
      url: endpoints.mypage.op3,
      method: 'post',
      data: paramsToFormData(params),
    }),    
  postMyBillList1: (params: ProjectListReqDto): Promise<CommonSearchListResDto> =>
    request({
      url: endpoints.mypage.bill,
      method: 'post',
      data: paramsToFormData(params),
    }),  
  postMyPaymentList1: (params: ProjectListReqDto): Promise<CommonSearchListResDto> =>
    request({
      url: endpoints.mypage.payment,
      method: 'post',
      data: paramsToFormData(params),
    }),          
  postMyMenuInfo: (params: ProjectListReqDto): Promise<CommonListResDto> =>
    request({
      url: endpoints.mypage.menu,
      method: 'post',
      data: paramsToFormData(params),
    }),  
  postMyBillHidden: (params: CommonReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.mypage.billhidden,
      method: 'post',
      data: paramsToFormData(params),
    }),
  postMyPaymentHidden: (params: CommonReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.mypage.paymenthidden,
      method: 'post',
      data: paramsToFormData(params),
    }),
};


